import React from "react";
import StakeSGTComponent from "./components/StakeSGTComponent";

const StakeSgt = () => {
  const renderView = () => {
    return <StakeSGTComponent />;
  };
  return <div>{renderView()}</div>;
};
export default StakeSgt;
